import React from "react";

import logo from "./janareallogo.jpg";

import {
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet,
    Svg,
    Circle,
    Rect,
    Line,
    Polygon,
    Ellipse,
} from "@react-pdf/renderer";

const COLORS = {
    black: "#111111",
    orange: "#F28C28",
    camel: "#C19A6B",
    lightCamel: "#F5EBDD",
    white: "#FFFFFF",
    gray: "#6B7280",
    border: "#E5E7EB",
    lightGray: "#F9FAFB",
};



const styles = StyleSheet.create({
    page: {
        paddingTop: 30,
        paddingBottom: 45,
        paddingHorizontal: 38,
        backgroundColor: COLORS.white,
        fontFamily: "Helvetica",
    },
    

    
structuredContentRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    columnGap: 8,
    rowGap: 6,
    width: "100%",
},

    header: {
        flexDirection: "row",
        alignItems: "center",
        paddingBottom: 12,
        borderBottomWidth: 2,
        borderBottomColor: COLORS.orange,
    },

    logo: {
        width: 52,
        height: 52,
        objectFit: "contain",
        marginRight: 12,
    },

    schoolInfo: {
        flex: 1,
    },

    schoolName: {
        fontSize: 17,
        fontWeight: "bold",
        color: COLORS.black,
        marginBottom: 4,
    },

    schoolContact: {
        fontSize: 7.5,
        color: COLORS.gray,
        lineHeight: 1.4,
    },

examBanner: {
    backgroundColor: "#c0bdbd",
    marginTop: 12,
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 4,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
},

examTitle: {
    color: "#1F1F1F",
    fontSize: 12,
    fontWeight: "bold",
},

examMarks: {
    color: "#FFFFFF",
    backgroundColor: "#000000",
    fontSize: 10,
    fontWeight: "bold",
    paddingVertical: 3,
    paddingHorizontal: 6,
    borderRadius: 3,
    alignSelf: "flex-start",
},

    paperTitle: {
        textAlign: "center",
        fontSize: 15,
        fontWeight: "bold",
        color: COLORS.black,
        marginTop: 16,
        marginBottom: 12,
    },

    studentInfo: {
        flexDirection: "row",
        flexWrap: "wrap",
        borderWidth: 1,
        borderColor: COLORS.border,
        borderRadius: 5,
        padding: 10,
        marginBottom: 12,
    },

    infoItem: {
        width: "50%",
        marginBottom: 8,
    },

    infoLabel: {
        fontSize: 7,
        color: COLORS.gray,
        textTransform: "uppercase",
        marginBottom: 3,
    },

    infoValue: {
        fontSize: 9,
        color: COLORS.black,
        fontWeight: "bold",
    },

    directionBox: {
        backgroundColor: COLORS.lightCamel,
        borderLeftWidth: 4,
        borderLeftColor: COLORS.orange,
        padding: 10,
        marginBottom: 18,
        borderRadius: 4,
    },

    directionTitle: {
        fontSize: 9,
        fontWeight: "bold",
        color: COLORS.black,
        marginBottom: 5,
    },

    directionText: {
        fontSize: 9,
        lineHeight: 1.5,
        color: COLORS.black,
    },

    sectionHeader: {
        backgroundColor: COLORS.black,
        paddingVertical: 7,
        paddingHorizontal: 10,
        marginTop: 12,
        marginBottom: 10,
        borderLeftWidth: 5,
        borderLeftColor: COLORS.orange,
        flexDirection: "row",
        justifyContent: "space-between",
    },

    sectionTitle: {
        color: COLORS.white,
        fontSize: 9,
        fontWeight: "bold",
        textTransform: "uppercase",
    },

    sectionMarks: {
        color: COLORS.orange,
        fontSize: 8,
        fontWeight: "bold",
    },

    question: {
        marginBottom: 14,
        paddingBottom: 8,
        borderBottomWidth: 0.5,
        borderBottomColor: "#DDDDDD",
    },

    questionRow: {
        flexDirection: "row",
        alignItems: "flex-start",
    },

    questionNumber: {
        width: 20,
        fontFamily: "Courier",
        fontSize: 10,
        lineHeight: 1.5,
        color: COLORS.black,
    },

    questionText: {
        fontSize: 9.5,
        lineHeight: 1.5,
        color: COLORS.black,
    },

    structuredText: {
        fontSize: 10,
        lineHeight: 1.5,
        color: COLORS.black,
        marginBottom: 5,
    },

    questionImage: {
        maxWidth: "100%",
        maxHeight: 170,
        marginTop: 8,
        marginBottom: 8,
        objectFit: "contain",
    },

    optionsGrid: {
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: 8,
    },

    option: {
        width: "50%",
        fontSize: 8.5,
        color: COLORS.black,
        paddingVertical: 4,
        paddingRight: 8,
    },

    // essay lines
    // answerLine: {
    //     borderBottomWidth: 0.7,
    //     borderBottomColor: COLORS.camel,
    //     marginTop: 14,
    // },

    drawingBox: {
        height: 150,
        borderWidth: 1,
        borderColor: COLORS.camel,
        marginTop: 10,
        borderRadius: 4,
    },

    footer: {
        position: "absolute",
        bottom: 18,
        left: 38,
        right: 38,
        borderTopWidth: 1,
        borderTopColor: COLORS.border,
        paddingTop: 6,
        flexDirection: "row",
        justifyContent: "space-between",
    },

    footerText: {
        fontSize: 7,
        color: COLORS.gray,
    },

    structuredBlock: {
        marginTop: 8,
        marginBottom: 8,
        padding: 8,
        borderWidth: 0.5,
        borderColor: COLORS.border,
        backgroundColor: COLORS.lightGray,
    },

    formulaText: {
        fontFamily: "Courier",
        fontSize: 11,
        color: COLORS.black,
    },

    fractionContainer: {
        alignItems: "center",
        justifyContent: "center",
        marginVertical: 8,
    },

    fractionNumerator: {
        fontFamily: "Times-Roman",
        fontSize: 14,
        textAlign: "center",
        paddingHorizontal: 10,
        paddingBottom: 3,
    },

    fractionLine: {
        width: 70,
        borderBottomWidth: 1,
        borderBottomColor: COLORS.black,
    },

    fractionDenominator: {
        fontFamily: "Times-Roman",
        fontSize: 14,
        textAlign: "center",
        paddingHorizontal: 10,
        paddingTop: 3,
    },

    graphTitle: {
        fontSize: 10,
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: 6,
    },

    graphAxisLabel: {
        fontSize: 7,
        color: COLORS.gray,
    },

    shapeWrapper: {
        marginTop: 8,
        marginBottom: 8,
        padding: 8,
        borderWidth: 0.5,
        borderColor: COLORS.border,
        alignItems: "center",
    },

    shapeLabel: {
        fontSize: 8,
        color: COLORS.black,
    },

    shapeCaption: {
        fontSize: 8,
        marginTop: 4,
        color: COLORS.gray,
    },

    table: {
        marginTop: 8,
        marginBottom: 8,
        borderWidth: 1,
        borderColor: COLORS.border,
    },

    tableRow: {
        flexDirection: "row",
    },

    tableCell: {
        flex: 1,
        padding: 5,
        fontSize: 8,
        borderRightWidth: 1,
        borderRightColor: COLORS.border,
        borderBottomWidth: 1,
        borderBottomColor: COLORS.border,
    },
});

const formatDate = (
    date
) => {
    if (!date) {
        return "________";
    }

    const parsed =
        new Date(date);

    if (
        Number.isNaN(
            parsed.getTime()
        )
    ) {
        return String(date);
    }

    return parsed.toLocaleString();
};

const renderAnswerLines = (
    count
) =>
    Array.from({
        length: count,
    }).map(
        (
            _,
            index
        ) => (
            <View
                key={index}
                style={
                    styles.answerLine
                }
            />
        )
    );

const parseStructuredPayload = (
    payload
) => {
    if (!payload) {
        return null;
    }

    if (
        typeof payload ===
        "string"
    ) {
        try {
            return JSON.parse(
                payload
            );
        } catch {
            return {
                blocks: [
                    {
                        type: "text",
                        text: payload,
                    },
                ],
            };
        }
    }

    return payload;
};

const getBlocks = (
    payload
) => {
    const content =
        parseStructuredPayload(
            payload
        );

    if (!content) {
        return [];
    }

    if (
        Array.isArray(
            content
        )
    ) {
        return content;
    }

    return (
        content.blocks ||
        content.structured_content
            ?.blocks ||
        content.content
            ?.blocks ||
        []
    );
};

const renderMathBlock = (
    block,
    index
) => {
    const latex =
        block.latex ||
        block.expression ||
        block.value ||
        "";

    return (
        <View
            key={index}
            style={
                styles.structuredBlock
            }
        >
            <Text
                style={
                    styles.formulaText
                }
            >
                {latex}
            </Text>
        </View>
    );
};

const renderFractionBlock = (
    block,
    index
) => (
    <View
        key={index}
        style={
            styles.fractionContainer
        }
    >
        <Text
            style={
                styles.fractionNumerator
            }
        >
            {block.numerator ||
                ""}
        </Text>

        <View
            style={
                styles.fractionLine
            }
        />

        <Text
            style={
                styles.fractionDenominator
            }
        >
            {block.denominator ||
                ""}
        </Text>
    </View>
);

const renderChemistryBlock = (
    block,
    index
) => (
    <View
        key={index}
        style={
            styles.structuredBlock
        }
    >
        <Text
            style={
                styles.formulaText
            }
        >
            {block.formula ||
                block.value ||
                block.expression ||
                ""}
        </Text>
    </View>
);

const getGraphPoints = (
    block
) => {
    if (
        Array.isArray(
            block.data
        )
    ) {
        return block.data
            .map(
                (
                    point
                ) => ({
                    x: Number(
                        point.x
                    ),
                    y: Number(
                        point.y
                    ),
                })
            )
            .filter(
                (
                    point
                ) =>
                    Number.isFinite(
                        point.x
                    ) &&
                    Number.isFinite(
                        point.y
                    )
            );
    }

    if (
        typeof block.data_text ===
        "string"
    ) {
        return block.data_text
            .split("\n")
            .map(
                (
                    line
                ) => {
                    const [
                        x,
                        y,
                    ] =
                        line.split(
                            ","
                        );

                    return {
                        x: Number(
                            x
                        ),
                        y: Number(
                            y
                        ),
                    };
                }
            )
            .filter(
                (
                    point
                ) =>
                    Number.isFinite(
                        point.x
                    ) &&
                    Number.isFinite(
                        point.y
                    )
            );
    }

    return [];
};

const renderGraphBlock = (
    block,
    index
) => {
    const points =
        getGraphPoints(
            block
        );

    const graphWidth =
        420;

    const graphHeight =
        220;

    const padding =
        35;

    const allX =
        points.map(
            (
                point
            ) => point.x
        );

    const allY =
        points.map(
            (
                point
            ) => point.y
        );

    const minX =
        allX.length
            ? Math.min(
                  ...allX
              )
            : 0;

    const maxX =
        allX.length
            ? Math.max(
                  ...allX
              )
            : 10;

    const minY =
        allY.length
            ? Math.min(
                  ...allY
              )
            : 0;

    const maxY =
        allY.length
            ? Math.max(
                  ...allY
              )
            : 10;

    const xRange =
        maxX - minX || 1;

    const yRange =
        maxY - minY || 1;

    const mapX = (
        x
    ) =>
        padding +
        ((x - minX) /
            xRange) *
            (graphWidth -
                padding *
                    2);

    const mapY = (
        y
    ) =>
        graphHeight -
        padding -
        ((y - minY) /
            yRange) *
            (graphHeight -
                padding *
                    2);

    return (
        <View
            key={index}
            style={
                styles.structuredBlock
            }
        >
            {block.title && (
                <Text
                    style={
                        styles.graphTitle
                    }
                >
                    {block.title}
                </Text>
            )}

            <Svg
                width={
                    graphWidth
                }
                height={
                    graphHeight
                }
                viewBox={`0 0 ${graphWidth} ${graphHeight}`}
            >
                <Line
                    x1={
                        padding
                    }
                    y1={
                        padding
                    }
                    x2={
                        padding
                    }
                    y2={
                        graphHeight -
                        padding
                    }
                    stroke={
                        COLORS.black
                    }
                    strokeWidth={
                        1
                    }
                />

                <Line
                    x1={
                        padding
                    }
                    y1={
                        graphHeight -
                        padding
                    }
                    x2={
                        graphWidth -
                        padding
                    }
                    y2={
                        graphHeight -
                        padding
                    }
                    stroke={
                        COLORS.black
                    }
                    strokeWidth={
                        1
                    }
                />

                {points.length >
                    1 &&
                    points
                        .slice(
                            0,
                            -1
                        )
                        .map(
                            (
                                point,
                                pointIndex
                            ) => {
                                const nextPoint =
                                    points[
                                        pointIndex +
                                            1
                                    ];

                                return (
                                    <Line
                                        key={`line-${pointIndex}`}
                                        x1={mapX(
                                            point.x
                                        )}
                                        y1={mapY(
                                            point.y
                                        )}
                                        x2={mapX(
                                            nextPoint.x
                                        )}
                                        y2={mapY(
                                            nextPoint.y
                                        )}
                                        stroke={
                                            COLORS.orange
                                        }
                                        strokeWidth={
                                            2
                                        }
                                    />
                                );
                            }
                        )}

                {points.map(
                    (
                        point,
                        pointIndex
                    ) => (
                        <Circle
                            key={`point-${pointIndex}`}
                            cx={mapX(
                                point.x
                            )}
                            cy={mapY(
                                point.y
                            )}
                            r={3}
                            fill={
                                COLORS.black
                            }
                        />
                    )
                )}

                {block.x_axis && (
                    <Text
                        x={
                            graphWidth /
                            2
                        }
                        y={
                            graphHeight -
                            5
                        }
                        textAnchor="middle"
                        style={
                            styles.graphAxisLabel
                        }
                    >
                        {
                            block.x_axis
                        }
                    </Text>
                )}

                {block.y_axis && (
                    <Text
                        x={12}
                        y={
                            graphHeight /
                            2
                        }
                        textAnchor="middle"
                        style={
                            styles.graphAxisLabel
                        }
                    >
                        {
                            block.y_axis
                        }
                    </Text>
                )}
            </Svg>
        </View>
    );
};

const renderCommonShapeLabels = (
    block,
    width,
    height
) => {
    const labels =
        block.labels || {};

    const dimensions =
        block.dimensions || {};

    return (
        <>
            {labels.top && (
                <Text
                    x={
                        width /
                        2
                    }
                    y={14}
                    textAnchor="middle"
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        labels.top
                    }
                </Text>
            )}

            {labels.left && (
                <Text
                    x={10}
                    y={
                        height /
                            2 -
                        6
                    }
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        labels.left
                    }
                </Text>
            )}

            {labels.right && (
                <Text
                    x={
                        width -
                        10
                    }
                    y={
                        height /
                            2 -
                        6
                    }
                    textAnchor="end"
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        labels.right
                    }
                </Text>
            )}

            {labels.bottom && (
                <Text
                    x={
                        width /
                        2
                    }
                    y={
                        height -
                        5
                    }
                    textAnchor="middle"
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        labels.bottom
                    }
                </Text>
            )}

            {labels.center && (
                <Text
                    x={
                        width /
                        2
                    }
                    y={
                        height /
                            2 +
                        4
                    }
                    textAnchor="middle"
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        labels.center
                    }
                </Text>
            )}

            {dimensions.top && (
                <Text
                    x={
                        width /
                        2
                    }
                    y={30}
                    textAnchor="middle"
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        dimensions.top
                    }
                </Text>
            )}

            {dimensions.left && (
                <Text
                    x={24}
                    y={
                        height /
                            2 +
                        18
                    }
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        dimensions.left
                    }
                </Text>
            )}

            {dimensions.right && (
                <Text
                    x={
                        width -
                        24
                    }
                    y={
                        height /
                            2 +
                        18
                    }
                    textAnchor="end"
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        dimensions.right
                    }
                </Text>
            )}

            {dimensions.bottom && (
                <Text
                    x={
                        width /
                        2
                    }
                    y={
                        height -
                        12
                    }
                    textAnchor="middle"
                    style={
                        styles.shapeLabel
                    }
                >
                    {
                        dimensions.bottom
                    }
                </Text>
            )}
        </>
    );
};

const renderShapeBlock = (
    block,
    index
) => {
    const originalWidth =
        Number(
            block.width
        ) || 320;

    const originalHeight =
        Number(
            block.height
        ) || 220;

    const maxWidth =
        360;

    const maxHeight =
        240;

    const scale =
        Math.min(
            maxWidth /
                originalWidth,
            maxHeight /
                originalHeight,
            1
        );

    const width =
        Math.max(
            80,
            Math.round(
                originalWidth *
                    scale
            )
        );

    const height =
        Math.max(
            80,
            Math.round(
                originalHeight *
                    scale
            )
        );

    const stroke =
        block.stroke ||
        COLORS.black;

    const strokeWidth =
        Math.min(
            Math.max(
                Number(
                    block.stroke_width
                ) || 3,
                1
            ),
            4
        );

    const fill =
        block.fill &&
        block.fill !==
            "transparent"
            ? block.fill
            : "none";

    const shapeType =
        block.shape_type ||
        block.shape ||
        "rectangle";

    const rotation =
        Number(
            block.rotation
        ) || 0;

    const innerWidth =
        Math.max(
            width - 40,
            40
        );

    const innerHeight =
        Math.max(
            height - 40,
            40
        );

    return (
        <View
            key={index}
            style={
                styles.shapeWrapper
            }
        >
            <Svg
                width={
                    width
                }
                height={
                    height
                }
                viewBox={`0 0 ${width} ${height}`}
            >
                <Svg
                    x={0}
                    y={0}
                    width={
                        width
                    }
                    height={
                        height
                    }
                    viewBox={`0 0 ${width} ${height}`}
                    transform={`rotate(${rotation} ${width / 2} ${height / 2})`}
                >
                    {shapeType ===
                        "triangle" && (
                        <Polygon
                            points={`
                                ${width / 2},22
                                22,${height - 24}
                                ${width - 22},${height - 24}
                            `}
                            stroke={
                                stroke
                            }
                            strokeWidth={
                                strokeWidth
                            }
                            fill={
                                fill
                            }
                        />
                    )}

                    {shapeType ===
                        "rectangle" && (
                        <Rect
                            x={20}
                            y={20}
                            width={
                                innerWidth
                            }
                            height={
                                innerHeight
                            }
                            stroke={
                                stroke
                            }
                            strokeWidth={
                                strokeWidth
                            }
                            fill={
                                fill
                            }
                        />
                    )}

                    {shapeType ===
                        "square" && (
                        <Rect
                            x={
                                (
                                    width -
                                    Math.min(
                                        width,
                                        height
                                    ) +
                                    40
                                ) /
                                2
                            }
                            y={
                                (
                                    height -
                                    Math.min(
                                        width,
                                        height
                                    ) +
                                    40
                                ) /
                                2
                            }
                            width={
                                Math.min(
                                    width,
                                    height
                                ) -
                                40
                            }
                            height={
                                Math.min(
                                    width,
                                    height
                                ) -
                                40
                            }
                            stroke={
                                stroke
                            }
                            strokeWidth={
                                strokeWidth
                            }
                            fill={
                                fill
                            }
                        />
                    )}

                    {shapeType ===
                        "circle" && (
                        <Circle
                            cx={
                                width /
                                2
                            }
                            cy={
                                height /
                                2
                            }
                            r={
                                Math.min(
                                    width,
                                    height
                                ) /
                                    2 -
                                24
                            }
                            stroke={
                                stroke
                            }
                            strokeWidth={
                                strokeWidth
                            }
                            fill={
                                fill
                            }
                        />
                    )}

                    {shapeType ===
                        "ellipse" && (
                        <Ellipse
                            cx={
                                width /
                                2
                            }
                            cy={
                                height /
                                2
                            }
                            rx={
                                width /
                                    2 -
                                24
                            }
                            ry={
                                height /
                                    2 -
                                24
                            }
                            stroke={
                                stroke
                            }
                            strokeWidth={
                                strokeWidth
                            }
                            fill={
                                fill
                            }
                        />
                    )}

                    {shapeType ===
                        "line" && (
                        <Line
                            x1={24}
                            y1={
                                height /
                                2
                            }
                            x2={
                                width -
                                24
                            }
                            y2={
                                height /
                                2
                            }
                            stroke={
                                stroke
                            }
                            strokeWidth={
                                strokeWidth
                            }
                        />
                    )}

                    {shapeType ===
                        "angle" && (
                        <>
                            <Line
                                x1={40}
                                y1={
                                    height -
                                    36
                                }
                                x2={
                                    width /
                                    2
                                }
                                y2={36}
                                stroke={
                                    stroke
                                }
                                strokeWidth={
                                    strokeWidth
                                }
                            />

                            <Line
                                x1={
                                    width /
                                    2
                                }
                                y1={36}
                                x2={
                                    width -
                                    40
                                }
                                y2={
                                    height -
                                    36
                                }
                                stroke={
                                    stroke
                                }
                                strokeWidth={
                                    strokeWidth
                                }
                            />

                            {block.angle_label && (
                                <Text
                                    x={
                                        width /
                                        2
                                    }
                                    y={
                                        height /
                                            2 +
                                        12
                                    }
                                    textAnchor="middle"
                                    style={
                                        styles.shapeLabel
                                    }
                                >
                                    {
                                        block.angle_label
                                    }
                                </Text>
                            )}
                        </>
                    )}

                    {shapeType ===
                        "parallel_lines" && (
                        <>
                            <Line
                                x1={32}
                                y1={
                                    height /
                                    2 -
                                    28
                                }
                                x2={
                                    width -
                                    32
                                }
                                y2={
                                    height /
                                    2 -
                                    28
                                }
                                stroke={
                                    stroke
                                }
                                strokeWidth={
                                    strokeWidth
                                }
                            />

                            <Line
                                x1={32}
                                y1={
                                    height /
                                    2 +
                                    28
                                }
                                x2={
                                    width -
                                    32
                                }
                                y2={
                                    height /
                                    2 +
                                    28
                                }
                                stroke={
                                    stroke
                                }
                                strokeWidth={
                                    strokeWidth
                                }
                            />
                        </>
                    )}

                    {shapeType ===
                        "perpendicular_lines" && (
                        <>
                            <Line
                                x1={
                                    width /
                                    2
                                }
                                y1={24}
                                x2={
                                    width /
                                    2
                                }
                                y2={
                                    height -
                                    24
                                }
                                stroke={
                                    stroke
                                }
                                strokeWidth={
                                    strokeWidth
                                }
                            />

                            <Line
                                x1={24}
                                y1={
                                    height /
                                    2
                                }
                                x2={
                                    width -
                                    24
                                }
                                y2={
                                    height /
                                    2
                                }
                                stroke={
                                    stroke
                                }
                                strokeWidth={
                                    strokeWidth
                                }
                            />
                        </>
                    )}

                    {renderCommonShapeLabels(
                        block,
                        width,
                        height
                    )}

                    {shapeType ===
                        "circle" &&
                        block.radius && (
                            <Text
                                x={
                                    width /
                                    2
                                }
                                y={
                                    height /
                                    2 +
                                    24
                                }
                                textAnchor="middle"
                                style={
                                    styles.shapeLabel
                                }
                            >
                                r ={" "}
                                {
                                    block.radius
                                }
                            </Text>
                        )}

                    {shapeType ===
                        "circle" &&
                        block.diameter && (
                            <Text
                                x={
                                    width /
                                    2
                                }
                                y={
                                    height -
                                    24
                                }
                                textAnchor="middle"
                                style={
                                    styles.shapeLabel
                                }
                            >
                                d ={" "}
                                {
                                    block.diameter
                                }
                            </Text>
                        )}
                </Svg>
            </Svg>

            <Text
                style={
                    styles.shapeCaption
                }
            >
                {shapeType.toUpperCase()}
            </Text>
        </View>
    );
};

const renderTableBlock = (
    block,
    index
) => {
    const rows =
        block.rows || [];

    return (
        <View
            key={index}
            style={
                styles.table
            }
        >
            {rows.map(
                (
                    row,
                    rowIndex
                ) => {
                    const cells =
                        Array.isArray(
                            row
                        )
                            ? row
                            : row.cells ||
                              [];

                    return (
                        <View
                            key={
                                rowIndex
                            }
                            style={
                                styles.tableRow
                            }
                        >
                            {cells.map(
                                (
                                    cell,
                                    cellIndex
                                ) => (
                                    <Text
                                        key={
                                            cellIndex
                                        }
                                        style={
                                            styles.tableCell
                                        }
                                    >
                                        {typeof cell ===
                                        "object"
                                            ? cell.text ||
                                              cell.value ||
                                              ""
                                            : String(
                                                  cell
                                              )}
                                    </Text>
                                )
                            )}
                        </View>
                    );
                }
            )}
        </View>
    );
};

// const renderStructuredContent = (
//     payload
// ) => {
//     const blocks =
//         getBlocks(
//             payload
//         );

//     if (
//         !blocks.length
//     ) {
//         return null;
//     }

//     return blocks.map(
//         (
//             block,
//             index
//         ) => {
//             if (!block) {
//                 return null;
//             }

//             const type =
//                 block.type ||
//                 block.kind ||
//                 block.element ||
//                 block.content_type;

//             if (
//                 type === "text" ||
//                 type === "paragraph"
//             ) {
//                 return (
//                     <Text
//                         key={
//                             index
//                         }
//                         style={
//                             styles.structuredText
//                         }
//                     >
//                         {block.text ||
//                             block.content ||
//                             block.value ||
//                             ""}
//                     </Text>
//                 );
//             }

//             if (
//                 type ===
//                     "math" ||
//                 type ===
//                     "mathematical_expression" ||
//                 type ===
//                     "equation" ||
//                 type ===
//                     "latex"
//             ) {
//                 return renderMathBlock(
//                     block,
//                     index
//                 );
//             }

//             if (
//                 type ===
//                 "fraction"
//             ) {
//                 return renderFractionBlock(
//                     block,
//                     index
//                 );
//             }

//             if (
//                 type ===
//                     "chemistry" ||
//                 type ===
//                     "chemical_formula"
//             ) {
//                 return renderChemistryBlock(
//                     block,
//                     index
//                 );
//             }

//             if (
//                 type ===
//                 "graph"
//             ) {
//                 return renderGraphBlock(
//                     block,
//                     index
//                 );
//             }

//             if (
//                 type ===
//                     "shape" ||
//                 type ===
//                     "geometry" ||
//                 type ===
//                     "geometric_shape"
//             ) {
//                 return renderShapeBlock(
//                     block,
//                     index
//                 );
//             }

//             if (
//                 type ===
//                 "table"
//             ) {
//                 return renderTableBlock(
//                     block,
//                     index
//                 );
//             }

//             if (
//                 type ===
//                 "image"
//             ) {
//                 const imageSource =
//                     block.src ||
//                     block.url ||
//                     block.image ||
//                     block.data;

//                 if (
//                     !imageSource
//                 ) {
//                     return null;
//                 }

//                 return (
//                     <Image
//                         key={
//                             index
//                         }
//                         src={
//                             imageSource
//                         }
//                         style={{
//                             maxWidth:
//                                 "100%",
//                             maxHeight: 180,
//                             objectFit:
//                                 "contain",
//                             marginTop: 8,
//                             marginBottom: 8,
//                         }}
//                     />
//                 );
//             }

//             return (
//                 <Text
//                     key={
//                         index
//                     }
//                     style={
//                         styles.structuredText
//                     }
//                 >
//                     {block.text ||
//                         block.content ||
//                         block.value ||
//                         ""}
//                 </Text>
//             );
//         }
//     );
// };

const renderStructuredContent = (payload) => {
    const blocks = getBlocks(payload);
    if (!blocks.length) {
        return null;
    }
    return (
        <View style={styles.structuredContentRow}>
            {blocks.map((block, index) => {
                if (!block) {
                    return null;
                }
                const type = block.type || block.kind || block.element || block.content_type;
                if (type === "text" || type === "paragraph") {
                    return (
                        <Text key={index} style={styles.structuredText}>
                            {block.text || block.content || block.value || ""}
                        </Text>
                    );
                }
                if (type === "math" || type === "mathematical_expression" || type === "equation" || type === "latex") {
                    return renderMathBlock(block, index);
                }
                if (type === "fraction") {
                    return renderFractionBlock(block, index);
                }
                if (type === "chemistry" || type === "chemical_formula") {
                    return renderChemistryBlock(block, index);
                }
                if (type === "graph") {
                    return renderGraphBlock(block, index);
                }
                if (type === "shape" || type === "geometry" || type === "geometric_shape") {
                    return renderShapeBlock(block, index);
                }
                if (type === "table") {
                    return renderTableBlock(block, index);
                }
                if (type === "image") {
                    const imageSource = block.src || block.url || block.image || block.data;
                    if (!imageSource) {
                        return null;
                    }
                    return (
                        <Image
                            key={index}
                            src={imageSource}
                            style={{
                                maxWidth: "100%",
                                maxHeight: 180,
                                objectFit: "contain",
                                marginTop: 8,
                                marginBottom: 8,
                            }}
                        />
                    );
                }
                return (
                    <Text key={index} style={styles.structuredText}>
                        {block.text || block.content || block.value || ""}
                    </Text>
                );
            })}
        </View>
    );
};

const renderQuestionText = (
    question,
    questionIndex
) => {
    const text =
        question.question_text ||
        "";

    return (
        <View
            style={
                styles.questionRow
            }
        >
            <Text
                style={
                    styles.questionNumber
                }
            >
                {questionIndex +
                    1}
                .{" "}
            </Text>

            <View
                style={{
                    flex: 1,
                }}
            >
                {text && (
                    <Text
                        style={
                            styles.questionText
                        }
                    >
                        {
                            text
                        }
                    </Text>
                )}

                {question.structured_payload && (
                    <View
                        style={{
                            marginTop: 6,
                        }}
                    >
                        {renderStructuredContent(
                            question.structured_payload
                        )}
                    </View>
                )}
            </View>
        </View>
    );
};

const renderStudentPage = (
    test,
    student,
    studentIndex
) => {
    const studentName =
        student?.full_name ||
        student?.student_name ||
        student?.name ||
        "____________________________";

    return (
        <Page
            key={
                student?.id ||
                studentIndex
            }
            size="A4"
            style={
                styles.page
            }
        >
            <View
                style={
                    styles.header
                }
            >
                <Image
                    src={
                        logo
                    }
                    style={
                        styles.logo
                    }
                />

                <View
                    style={
                        styles.schoolInfo
                    }
                >
                    <Text
                        style={
                            styles.schoolName
                        }
                    >
                        Jana L. Williams Educational Foundation School System
                    </Text>

                    <Text
                        style={
                            styles.schoolContact
                        }
                    >
                        New Store Community, Mt. Barclay, Montserrado County, Liberia
                    </Text>

                    <Text
                        style={
                            styles.schoolContact
                        }
                    >
                        +231-886909466 / +231-770123025
                    </Text>

                    <Text
                        style={
                            styles.schoolContact
                        }
                    >
                        salvationinchristministries@gmail.com
                    </Text>
                </View>
            </View>

            <View
                style={
                    styles.examBanner
                }
            >
                <Text
                    style={
                        styles.examTitle
                    }
                >
                    {test.subject_name ||
                        "SUBJECT"}
                    {"  •  "}
                    {test.period_name ||
                        "TEST"}
                </Text>

                <Text
                    style={
                        styles.examMarks
                    }
                >
                    TOTAL MARKS:{" "}
                    {test.total_marks ||
                        0}
                </Text>
            </View>

            <Text
                style={
                    styles.paperTitle
                }
            >
                STUDENT TEST PAPER
            </Text>

            <View
                style={
                    styles.studentInfo
                }
            >
                <View
                    style={
                        styles.infoItem
                    }
                >
                    <Text
                        style={
                            styles.infoLabel
                        }
                    >
                        Grade Class
                    </Text>

                    <Text
                        style={
                            styles.infoValue
                        }
                    >
                        {test.grade_class_name ||
                            "________"}
                    </Text>
                </View>

                <View
                    style={
                        styles.infoItem
                    }
                >
                    <Text
                        style={
                            styles.infoLabel
                        }
                    >
                        Subject
                    </Text>

                    <Text
                        style={
                            styles.infoValue
                        }
                    >
                        {test.subject_name ||
                            "________"}
                    </Text>
                </View>

                <View
                    style={
                        styles.infoItem
                    }
                >
                    <Text
                        style={
                            styles.infoLabel
                        }
                    >
                        Start Time
                    </Text>

                    <Text
                        style={
                            styles.infoValue
                        }
                    >
                        {formatDate(
                            test.start_time
                        )}
                    </Text>
                </View>

                <View
                    style={
                        styles.infoItem
                    }
                >
                    <Text
                        style={
                            styles.infoLabel
                        }
                    >
                        End Time
                    </Text>

                    <Text
                        style={
                            styles.infoValue
                        }
                    >
                        {formatDate(
                            test.end_time
                        )}
                    </Text>
                </View>

                <View
                    style={
                        styles.infoItem
                    }
                >
                    <Text
                        style={
                            styles.infoLabel
                        }
                    >
                        Student Name
                    </Text>

                    <Text
                        style={
                            styles.infoValue
                        }
                    >
                        {
                            studentName
                        }
                    </Text>
                </View>

                <View
                    style={
                        styles.infoItem
                    }
                >
                    <Text
                        style={
                            styles.infoLabel
                        }
                    >
                        Date
                    </Text>

                    <Text
                        style={
                            styles.infoValue
                        }
                    >
                        __________________
                    </Text>
                </View>
            </View>

            {test.direction && (
                <View
                    style={
                        styles.directionBox
                    }
                >
                    <Text
                        style={
                            styles.directionTitle
                        }
                    >
                        GENERAL INSTRUCTIONS
                    </Text>

                    <Text
                        style={
                            styles.directionText
                        }
                    >
                        {
                            test.direction
                        }
                    </Text>
                </View>
            )}

            {(test.sections ||
                []).map(
                (
                    section,
                    sectionIndex
                ) => (
                    <View
                        key={
                            section.id ||
                            sectionIndex
                        }
                    >
                        <View
                            style={
                                styles.sectionHeader
                            }
                        >
                            <Text
                                style={
                                    styles.sectionTitle
                                }
                            >
                                Section{" "}
                                {sectionIndex +
                                    1}
                                {" — "}
                                {(
                                    section.question_type ||
                                    ""
                                )
                                    .replace(
                                        /_/g,
                                        " "
                                    )
                                    .toUpperCase()}
                            </Text>

                            <Text
                                style={
                                    styles.sectionMarks
                                }
                            >
                                {section.allocated_marks ||
                                    0}{" "}
                                MARKS
                            </Text>
                        </View>

                        {(section.questions ||
                            []).map(
                            (
                                question,
                                questionIndex
                            ) => (
                                <View
                                    key={
                                        question.id ||
                                        questionIndex
                                    }
                                    style={
                                        styles.question
                                    }
                                >
                                    {renderQuestionText(
                                        question,
                                        questionIndex
                                    )}

                                    <Text
                                        style={
                                            styles.questionText
                                        }
                                    >
                                        (
                                        {
                                            question.marks ||
                                            0
                                        }{" "}
                                        mark
                                        {Number(
                                            question.marks
                                        ) >
                                        1
                                            ? "s"
                                            : ""}
                                        )
                                    </Text>

                                    {question.question_image_base64 && (
                                        <Image
                                            src={
                                                question.question_image_base64
                                            }
                                            style={
                                                styles.questionImage
                                            }
                                        />
                                    )}

                                    {section.question_type ===
                                        "multiple_choice" && (
                                        <View
                                            style={
                                                styles.optionsGrid
                                            }
                                        >
                                            <Text
                                                style={
                                                    styles.option
                                                }
                                            >
                                                A.{" "}
                                                {question.option_a ||
                                                    ""}
                                            </Text>

                                            <Text
                                                style={
                                                    styles.option
                                                }
                                            >
                                                B.{" "}
                                                {question.option_b ||
                                                    ""}
                                            </Text>

                                            <Text
                                                style={
                                                    styles.option
                                                }
                                            >
                                                C.{" "}
                                                {question.option_c ||
                                                    ""}
                                            </Text>

                                            <Text
                                                style={
                                                    styles.option
                                                }
                                            >
                                                D.{" "}
                                                {question.option_d ||
                                                    ""}
                                            </Text>
                                        </View>
                                    )}

                                    {section.question_type ===
                                        "fill_blank" &&
                                        renderAnswerLines(
                                            1
                                        )}
{/* 
                                    {section.question_type ===
                                        "essay" &&
                                        renderAnswerLines(
                                            7
                                        )} */}

                                    {section.question_type ===
                                        "paragraph" &&
                                        renderAnswerLines(
                                            5
                                        )}

                                    {section.question_type ===
                                        "short_answer" &&
                                        renderAnswerLines(
                                            2
                                        )}

                                    {section.question_type ===
                                        "true_false" && (
                                        <View
                                            style={{
                                                flexDirection:
                                                    "row",
                                                marginTop: 10,
                                            }}
                                        >
                                            <Text
                                                style={{
                                                    marginRight: 30,
                                                    fontSize: 9,
                                                }}
                                            >
                                                ☐ TRUE
                                            </Text>

                                            <Text
                                                style={{
                                                    fontSize: 9,
                                                }}
                                            >
                                                ☐ FALSE
                                            </Text>
                                        </View>
                                    )}

                                    {section.question_type ===
                                        "drawing" && (
                                        <View
                                            style={
                                                styles.drawingBox
                                            }
                                        />
                                    )}
                                </View>
                            )
                        )}
                    </View>
                )
            )}

            <View
                style={
                    styles.footer
                }
                fixed
            >
                <Text
                    style={
                        styles.footerText
                    }
                >
                    Jana L. Williams Educational Foundation School System
                </Text>

                <Text
                    style={
                        styles.footerText
                    }
                    render={({
                        pageNumber,
                        totalPages,
                    }) =>
                        `Page ${pageNumber} of ${totalPages}`
                    }
                />

                <Text
                    style={
                        styles.footerText
                    }
                >
                    Powered by Polu Integrated Technology
                </Text>
            </View>
        </Page>
    );
};

const TestPDF = ({
    test,
    students = [],
}) => {
    if (!test) {
        return (
            <Document>
                <Page
                    size="A4"
                    style={
                        styles.page
                    }
                >
                    <Text>
                        No test data available.
                    </Text>
                </Page>
            </Document>
        );
    }

    return (
        <Document>
            {students.length >
            0
                ? students.map(
                      (
                          student,
                          studentIndex
                      ) =>
                          renderStudentPage(
                              test,
                              student,
                              studentIndex
                          )
                  )
                : renderStudentPage(
                      test,
                      null,
                      0
                  )}
        </Document>
    );
};

export default TestPDF;





